import React, { useState } from "react";
import styled from "styled-components";

const Shop = styled.div`
  width: 43%;
  height: 230px;
  background: yellow;
  margin: 0 2% 2% 0;
  background: white;
  border: 1px solid #eee;
  padding: 2%;
`;
const ShopTitle = styled.h3`
  font-weight: 500;
  margin: 0;
  padding: 5px 0;
`;
const SecondTitle = styled.p`
  margin: 0;
  padding: 3px 0;
  color: gray;
`;
const Button1 = styled.button`
  width: 48.5%;
  padding: 10px;
  margin: 5px 5% 0 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
`;
const Button2 = styled.button`
  width: 45%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  font-size: 1em;
  cursor: pointer;
`;
const SelectInput = styled.select`
  padding: 5px 15px;
`;
function ShopItem(props) {
  const [days, setDays] = useState(30);
  const planHandler = (e) => {
    setDays(e.target.value);
  };
  return (
    <Shop>
      <ShopTitle>{props.shop.name}</ShopTitle>
      <SecondTitle>{props.shop.categoryName}</SecondTitle>
      <SecondTitle>{props.shop.phone}</SecondTitle>
      <SecondTitle>{props.shop.email}</SecondTitle>
      <SecondTitle>
        {props.shop.cityName}, {props.shop.thanaName}
      </SecondTitle>
      <div style={{ margin: "5px 0" }}>
        <p style={{ padding: "0", margin: "5px 0" }}>Select a plan</p>
        <SelectInput onChange={planHandler}>
          <option value={30}>30 days</option>
          <option value={60}>60 days</option>
          <option value={120}>120 days</option>
          <option value={365}>365 days</option>
        </SelectInput>
      </div>
      <Button1
        onClick={() => {
          props.onBoardHandler(props.shop._id, days);
        }}
      >
        On board
      </Button1>
      <Button2 onClick={() => props.cancelModaHandler(props.shop._id)}>
        Cancel
      </Button2>
    </Shop>
  );
}

export default ShopItem;
